/* UpCart owns the cart. The theme's after-add setting is "drawer", so after every add (and on
   the header cart icon) Symmetry also opened its own cart drawer: UpCart hides that drawer with
   CSS, but the theme overlay (.js-overlay) stayed on screen, stacked under UpCart's backdrop
   and outliving it, leaving the page dimmed and blocking taps.

   While UpCart is running, the theme drawer's open() hands off to UpCart and never touches the
   overlay. The mobile menu drawer shares the overlay and is untouched. If UpCart fails to load,
   the theme drawer works as before. */
(function () {
  function patch() {
    var drawer = document.querySelector('.js-cart-drawer');
    if (!drawer || drawer.__kiaUpcart || typeof drawer.open !== 'function') return;
    var themeOpen = drawer.open;
    drawer.open = function () {
      if (typeof window.upcartOpenCart === 'function') {
        try { window.upcartOpenCart(); } catch (e) {}
        return;
      }
      return themeOpen.apply(this, arguments);
    };
    drawer.__kiaUpcart = true;
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(patch);
  }
  document.addEventListener('DOMContentLoaded', patch);
})();
